import {
  Audit,
  BasketballGameJudgeSuggestion,
  BasketballGameOnSameDay,
  BasketballTeamBasic,
  Car,
  CarBasic,
  EventHelpout,
  Gym,
  Task,
  UserBasic,
} from '../_generated/openapi';
import { BasketballEvent, BasketballEventUserData } from './basketball-event';
import { BasketballGameCommentPagination } from './basketball-game-comment';
import { BasketballLeague } from './basketball-league';
import { BasketballTeam, BasketballTeamGameCarpool } from './basketball-team';
import { BasketballTeamTask } from './basketball-team-task';

export enum BasketballGameStatus {
  SCHEDULED = 0,
  POSTPONED = 1,
  CANCELED = 2,
  FINISHED = 3,
}

export interface BasketballGameReport {
  id: number;
  title: string;
  eventable_id: number;
  eventable_type: string;
  created_at: string;
}

export interface BasketballClubGame {
  id: number;
  club_id: number;
  created_at?: Date | null;
  game_id: number;
  guest_team_id?: number | null;
  home_team_id?: number | null;
  is_home?: number | null;
  is_home_flag?: boolean;
  judge_24sec_id?: number | null;
  judge_paper_asst_id?: number | null;
  judge_paper_id?: number | null;
  judge_team_id?: number | null;
  judge_time_id?: number | null;
  kiosk: boolean;
  note?: string | null;
  own_referee1_id?: number | null;
  own_referee2_id?: number | null;
  own_referees: boolean;
  preferred_date?: Date | null;
  preferred_location?: string | null;
  responsible_user_id?: number | null;
  score_sheet_sent?: string | null;
  updated_at?: Date | null;
  // Extra data
  referee1?: UserBasic | null;
  referee2?: UserBasic | null;
  judge_team?: BasketballTeamBasic | null;
  judge_paper?: UserBasic | null;
  judge_paper_asst?: UserBasic | null;
  judge_time?: UserBasic | null;
  judge24_sec?: UserBasic | null;
  responsible_user?: UserBasic | null;
  editableJudges?: boolean;
  judge_suggestions?: BasketballGameJudgeSuggestion[];
  tasks?: Task[];
  reports?: BasketballGameReport[];
}

export interface BasketballTeamGame {
  id: number;
  car_id?: number | null;
  created_at?: Date | null;
  game_id: number;
  meet_at?: string | null;
  meet_at_location?: string | null;
  note?: string | null;
  team_id: number;
  updated_at?: Date | null;
  // Extra Data
  jerseys?: UserBasic | null;
  car?: Car | null;
  cars?: CarBasic[];
  team?: BasketballTeam | null;
  user_players?: UserBasic[];
  user_coaches?: UserBasic[];
  comments?: BasketballGameCommentPagination;
  carpool?: BasketballTeamGameCarpool[];
  nominees: number[];
  helpouts: EventHelpout[];
  reports?: BasketballGameReport[];
}

export interface BasketballGame {
  created_at?: string | null;
  date: string;
  game_id: number;
  game_number: number;
  guest: string;
  guest_teamname?: string | null;
  guest_id: number;
  gym?: string | null;
  gym_address?: string | null;
  gym_address_lines?: {
    line_1: string;
    line_2: string;
  } | null;
  home: string;
  home_teamname?: string | null;
  home_id: number;
  id: number;
  league_id?: number | null;
  points_guest?: number | null;
  points_home?: number | null;
  referee_1?: string | null;
  referee_2?: string | null;
  status: BasketballGameStatus;
  updated_at?: Date | null;
  // Extra data
  hygiene_concept_url?: string | null;
  audits: Audit[];
  club_details?: BasketballClubGame | null;
  home_team?: BasketballTeam | null;
  guest_team?: BasketballTeam | null;
  gym_details?: Gym | null;
  league: BasketballLeague;
  team_details?: BasketballTeamGame[] | null;
  game_tasks?: BasketballTeamTask[] | null;
  contains_children_data: boolean;
  user_data: BasketballEventUserData[];
  event?: BasketballEvent;
  other_games?: BasketballGameOnSameDay[];
}
